import api from '../config/api';

export const getProjects = searchParams => api.get(`/projects${searchParams}`);
